/* tslint:disable */
/* eslint-disable */
/**
 * mama health backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserDetailsDto
 */
export interface UpdateUserDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDetailsDto
     */
    conditionStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDetailsDto
     */
    medications?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDetailsDto
     */
    careProvider?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDetailsDto
     */
    conditionVariant?: string;
}

/**
 * Check if a given object implements the UpdateUserDetailsDto interface.
 */
export function instanceOfUpdateUserDetailsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateUserDetailsDtoFromJSON(json: any): UpdateUserDetailsDto {
    return UpdateUserDetailsDtoFromJSONTyped(json, false);
}

export function UpdateUserDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserDetailsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'conditionStartDate': !exists(json, 'conditionStartDate') ? undefined : json['conditionStartDate'],
        'medications': !exists(json, 'medications') ? undefined : json['medications'],
        'careProvider': !exists(json, 'careProvider') ? undefined : json['careProvider'],
        'conditionVariant': !exists(json, 'conditionVariant') ? undefined : json['conditionVariant'],
    };
}

export function UpdateUserDetailsDtoToJSON(value?: UpdateUserDetailsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'conditionStartDate': value.conditionStartDate,
        'medications': value.medications,
        'careProvider': value.careProvider,
        'conditionVariant': value.conditionVariant,
    };
}

